<template>
  <v-container>

    <v-card>
      <v-toolbar flat color="blue accent-2" class="white--text">
        <v-btn to="/" icon text>
          <v-icon small class="white--text">mdi-home</v-icon>
        </v-btn>
        <v-toolbar-title>
          <h3 class="font-weight-light">Ucsis Type</h3>
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <loader v-if="isloading"></loader>

        <v-row dense>
          <v-col class="mt-2" cols="12">
            <v-btn :to="`/crear-ucsis-type`" depressed rounded class="white--text" color="green">
              nuevo
            </v-btn>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <v-data-table :headers="headers" :items="items" disable-pagination hide-default-footer item-key="key" class="elevation-1 mt-6">

              <template v-slot:item.action="{ item }">

                <router-link :to="`/crear-ucsis-type?id=${item.id}`">
                  <v-icon small class="mr-2" color="blue">
                    mdi-pencil
                  </v-icon>
                </router-link>

                <v-icon @click="deleteUcsis(item)" small color="red lighten-1">
                  mdi-trash-can
                </v-icon>
              </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>


  </v-container>
</template>

<script>
  import {
    ucsis_service
  } from '~/ucsis_service'

  export default {

    data() {
      return {
        items: [],

        headers: [{
            text: 'Tipo',
            value: 'type',
            width: 120
          },
          {
            text: 'Titulo',
            value: 'title',
          },
          {
            text: 'Acciones',
            value: 'action',
            sortable: false
          },
        ],
      }
    },

    created() {
      this.getUcsis()
    },

    methods: {
      getUcsis() {
        ucsis_service.get_ucsis().then(res => {
          this.items = res.data
        }, res => {
          this.$toast.error('Error consultando registro')
        })
      },

      deleteUcsis(item) {
        ucsis_service.delete_ucsis(item.id).then(res => {
          this.items.splice(this.items.indexOf(item), 1)
          this.$toast.sucs('Registro eliminado con exito')
        }, res => {
          this.$toast.error('Error eliminando registro')
        })
      }
    },
    computed: {
      isloading() {
        return this.$store.getters.getloading
      },
      errors() {
        return this.$store.getters.geterrors
      },
      user() {
        return JSON.parse(localStorage.getItem('user'))
      },
      categoria() {
        return this.$store.getters.get_categoria
      }
    }
  }
</script>